__turbopack_context__.v({
  "appBadgesContainer": "ViChGq_appBadgesContainer",
  "appIcon": "ViChGq_appIcon",
  "badges": "ViChGq_badges",
  "card": "ViChGq_card",
  "card--titled": "ViChGq_card--titled",
  "content": "ViChGq_content",
  "content--compact": "ViChGq_content--compact",
  "content--titled": "ViChGq_content--titled",
  "desktopText": "ViChGq_desktopText",
  "mobileText": "ViChGq_mobileText",
  "qrCodeContainer": "ViChGq_qrCodeContainer",
  "textContainer": "ViChGq_textContainer",
});
